export default "__VITE_ASSET__BNDctabo__"